export const arrow = (
  <svg
    width='15'
    height='10'
    viewBox='0 0 15 10'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.4226 0.244078C14.748 0.569515 14.748 1.09715 14.4226 1.42259L6.67851 9.16667C6.02764 9.81754 4.97236 9.81754 4.32149 9.16667L0.744078 5.58926C0.418641 5.26382 0.418641 4.73618 0.744078 4.41074C1.06951 4.08531 1.59715 4.08531 1.92259 4.41074L5.5 7.98816L13.2441 0.244078C13.5695 -0.0813592 14.0972 -0.0813592 14.4226 0.244078Z'
      fill='#5C369A'
    />
  </svg>
);

export const phone = (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.50748 2.28431C5.94775 1.87171 5.57083 1.77856 5.36858 1.81802C4.5342 1.98086 4.0396 2.30566 3.3695 2.97576C2.45482 3.89043 2.01101 4.5734 2.20431 5.60892C2.42686 6.80114 3.51411 8.62076 6.51079 11.6175C9.50726 14.6139 11.3379 15.7126 12.5368 15.9399C13.0924 16.0452 13.5155 15.9628 13.8951 15.7758C14.301 15.5759 14.6919 15.2394 15.1401 14.7716C15.5377 14.3566 15.779 14.0671 15.9478 13.7822C16.1086 13.5108 16.2226 13.2107 16.3107 12.7599C16.3502 12.5577 16.257 12.1807 15.8443 11.6209C15.4594 11.0988 14.9164 10.5803 14.4145 10.157C14.0832 9.87773 13.5707 9.85995 13.1567 10.1699L11.8914 11.1171C10.7501 11.9714 9.15535 11.849 8.14843 10.8421L7.28614 9.97982C6.27922 8.9729 6.15683 7.37813 7.0112 6.23684L7.95835 4.97161C8.26828 4.5576 8.25048 4.0451 7.97114 3.71384C7.54791 3.21195 7.02947 2.6691 6.50748 2.28431ZM7.49642 0.942756C8.17095 1.43999 8.78678 2.09572 9.24526 2.63941C10.081 3.63043 10.0128 5.00834 9.29258 5.97041L8.34543 7.23564C7.99255 7.70702 8.03816 8.37482 8.46465 8.80131L9.32694 9.6636C9.75343 10.0901 10.4212 10.1357 10.8926 9.78282L12.1579 8.83563C13.1199 8.11546 14.4978 8.04726 15.4888 8.88286C16.0326 9.34137 16.6885 9.95728 17.1859 10.6319C17.6554 11.2688 18.1278 12.1508 17.9464 13.0795C17.8299 13.6758 17.6589 14.1638 17.3816 14.6318C17.1124 15.0863 16.7625 15.4874 16.3436 15.9246C15.858 16.4314 15.3045 16.9396 14.6316 17.271C13.9324 17.6153 13.1423 17.751 12.2264 17.5774C10.4822 17.2468 8.33649 15.8002 5.33228 12.796C2.32827 9.79194 0.890869 7.65544 0.565942 5.91474C0.211763 4.01734 1.19766 2.79056 2.191 1.79724C3.01149 0.976758 3.7895 0.428082 5.04935 0.182217C5.97778 0.00102814 6.85963 0.473341 7.49642 0.942756Z'
      fill='white'
    />
  </svg>
);
